const ImageCache = new Map();

export default function loadImage(url, crossOrigin = '') {
    return new Promise((resolve, reject) => {
        const data = ImageCache.get(url);

        if (data) {
            resolve(data);
        } else {
            const image = new Image();
            let locked = false;

            ImageCache.set(url, image);

            image.addEventListener('error', () => {
                reject();
            });

            image.addEventListener('load', () => {
                if (locked) {
                    return;
                }
                locked = true;

                resolve(image);
            });

            image.crossOrigin = crossOrigin;
            image.src = url;
        }
    });
}
